module.exports = __webpack_public_path__ + "img/logo_spes_order.746dd82f.svg";